import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaceFormsState } from '../state/pace-forms.state';
import { initialNotificationFormListState } from '../../store/state/notification-form-list.state';
import { initialDocBoxState } from '../../store/state/docBox.state';
import { initialFormState } from '../../store/state/form.state';
import { initialLastOpenedFormState } from '../state/last-opened-form.state';
import { initialServiceActivityState } from '../state/service-activity.state';

export const getPaceFormsState = createFeatureSelector<PaceFormsState>('paceForms');

export const getServiceActivityType = createSelector(getPaceFormsState, (formsState) => formsState.serviceActivity);

export const getIsEmptyPaceFormsState = createSelector(getPaceFormsState, (formsState) => {
    return (
        formsState.form === initialFormState &&
        formsState.lastOpenedForm === initialLastOpenedFormState &&
        formsState.serviceActivity === initialServiceActivityState &&
        formsState.docBox === initialDocBoxState &&
        formsState.lists === initialNotificationFormListState
    );
});
